module.exports = __webpack_public_path__ + "static/media/vrsec_logo.b99580dd.png";